import React, { Component } from 'react';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//components:
import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { navigate, openDialog, hideDialog, setSaveState } from '../../actions';
import { getTiposMaquina } from '../../actions/tipos_maquina_actions';
import { getModelosMaquina, modifyModeloMaquina, removeModeloMaquina, addModeloMaquina, updateModelosMaquinaDB } from '../../actions/modelos_maquina_actions';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    marginBottom: {
        marginBottom: 20,
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        marginLeft: 8,
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeAuxiliaresModeloMaquina extends Component {

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getModelosMaquina();
        this.props.getTiposMaquina();
    };

    messageDialog = msg => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkVModeloMaquina = modeloMaquina => {
        if (this.props.modelosMaquina.find(c => (c.descr === modeloMaquina.descr) && (c.id !== modeloMaquina.id))) {
            this.messageDialog(`Ya existe un modelo de máquina ${modeloMaquina.descr}`);
            return false;
        } else if (!modeloMaquina.descr.trim()) {
            this.messageDialog('Por favor, introduzca una descripción');
            return false;
        } else if (isNaN(modeloMaquina.tipoRegalo)) {
            this.messageDialog('Por favor, introduzca un tipo de regalo');
            return false;
        }

        else return true;
    };

    editModeloMaquina = modeloMaquina => {
        this.props.openDialog('EditVModeloMaquina', {
            modelomaquina: modeloMaquina,
            tiposMaquina: this.props.tiposMaquina,
            checkVModeloMaquina: this.checkVModeloMaquina,
            okHandler: (m) => {
                this.props.setSaveState(true);
                this.props.modifyModeloMaquina(m);
            },

        }, uuidv4());
    };

    newModeloMaquina = () => {
        this.props.openDialog('EditVModeloMaquina', {
            modelomaquina: {},
            tiposMaquina: this.props.tiposMaquina,
            okHandler: (m) => {
                this.props.setSaveState(true);
                this.props.addModeloMaquina(m);
            },
            checkVModeloMaquina: this.checkVModeloMaquina,
        }, uuidv4());
    };

    handleGridRowsUpdated = ({ fromRow, toRow, fromRowData, updated }) => {

        if (fromRow !== toRow) return; //solo modificamos una fila

        // for (let i = fromRow; i <= toRow; i++) {
        //     let updatedRow = update(this.props.modelosMaquina[i], { $merge: updated });
        //     this.props.setSaveState(true);
        //     this.props.modifyModeloMaquina(updatedRow);
        // };

        let updatedRow = update(this.props.modelosMaquina[fromRowData.grid_index], { $merge: updated });
        this.props.setSaveState(true);
        this.props.modifyModeloMaquina(updatedRow);

    };

    handleDeleteRow = modeloMaquina => {
        this.props.setSaveState(true);
        this.props.removeModeloMaquina(modeloMaquina);
    };

    render() {

        const { classes } = this.props;



        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <div className={classes.marginBottom}>
                    <NeuriteGrid
                        id="m_a_m_m"
                        columns={[
                            { key: 'cvTipoMaquinaDescr', name: 'Tipo Máquina', editable: false, dragable: false, width: 105 },
                            { key: 'descr', name: 'Descripción', editable: true, dragable: false, width: 130 },
                            { key: 'tieneContador', name: 'Tiene Contador', type: 'bool', dragable: false, width: 105 },
                            { key: 'tipoRegalo', name: 'Tipo Regalo', dragable: false, type: 'int', width: 85 }
                        ]}
                        rows={this.props.modelosMaquina}
                        height={500}
                        buttonEdit={true}
                        buttonDelete={true}
                        buttonNew={true}
                        onNewRowClick={this.newModeloMaquina}
                        onEditClick={this.editModeloMaquina}
                        onRowsUpdated={this.handleGridRowsUpdated}
                        onDeleteClick={this.handleDeleteRow}
                        enableFilter={true}

                    />
                </div>

                <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                    this.props.modelosMaquina.forEach(e => {
                        if (typeof e.id !== 'number') e.id = -1;
                    });

                    this.props.updateModelosMaquinaDB(this.props.modelosMaquina)
                }}>Guardar</Button>
            </div >
        );

    };

};

MaeAuxiliaresModeloMaquina.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    tiposMaquina: PropTypes.array.isRequired,
    modelosMaquina: PropTypes.array.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    getModelosMaquina: PropTypes.func.isRequired,
    getTiposMaquina: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    modifyModeloMaquina: PropTypes.func.isRequired,
    removeModeloMaquina: PropTypes.func.isRequired,
    addModeloMaquina: PropTypes.func.isRequired,
    updateModelosMaquinaDB: PropTypes.func.isRequired
};

function mapStateToProps(state) {

    return {
        user: state.oidc.user,
        modelosMaquina: state.modelosMaquina.modelosmaquina,
        tiposMaquina: state.tiposMaquina.tiposmaquina,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getTiposMaquina,
        getModelosMaquina,
        openDialog,
        hideDialog,
        modifyModeloMaquina,
        removeModeloMaquina,
        addModeloMaquina,
        updateModelosMaquinaDB,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(MaeAuxiliaresModeloMaquina));

